// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
import { darkColorBase, lightColorBase } from "./base";

export const lightColorPalette = {
  button: {
    primary: {
      bg: {
        default: lightColorBase["brand"]["iris"]["500"],
        hover: lightColorBase["brand"]["iris"]["600"],
        down: lightColorBase["brand"]["iris"]["700"],
      },
      text: lightColorBase["neutral"]["base"]["white"],
      icon: lightColorBase["neutral"]["base"]["white"],
    },
    secondary: {
      bg: {
        default: lightColorBase["neutral"]["ghost"]["25"],
        hover: lightColorBase["brand"]["ultramarine"]["100"],
        down: lightColorBase["brand"]["ultramarine"]["200"],
      },
      text: lightColorBase["brand"]["iris"]["500"],
      outline: lightColorBase["brand"]["iris"]["500"],
      icon: lightColorBase["brand"]["iris"]["500"],
    },
    disabled: {
      bg: {
        disabled: lightColorBase["transparent"]["4"],
      },
      text: lightColorBase["transparent"]["20"],
      icon: lightColorBase["transparent"]["20"],
    },
    danger: {
      bg: {
        default: lightColorBase["brand"]["persianRed"]["600"],
        hover: lightColorBase["brand"]["persianRed"]["700"],
        down: lightColorBase["brand"]["persianRed"]["800"],
      },
      text: lightColorBase["neutral"]["base"]["white"],
      icon: lightColorBase["neutral"]["base"]["white"],
    },
    dangerSecondary: {
      bg: {
        default: lightColorBase["neutral"]["ghost"]["25"],
        hover: lightColorBase["brand"]["persianRed"]["100"],
        down: lightColorBase["brand"]["persianRed"]["200"],
      },
      text: lightColorBase["brand"]["persianRed"]["600"],
      outline: lightColorBase["brand"]["persianRed"]["600"],
      icon: lightColorBase["brand"]["persianRed"]["600"],
    },
    strong: {
      icon: lightColorBase["neutral"]["base"]["white"],
      text: lightColorBase["neutral"]["base"]["white"],
      bg: {
        default: lightColorBase["neutral"]["granite"]["900"],
        hover: lightColorBase["neutral"]["granite"]["800"],
        down: lightColorBase["neutral"]["granite"]["700"],
      },
    },
  },
  elevation: {
    surface: {
      default: lightColorBase["neutral"]["ghost"]["100"],
      raised: lightColorBase["neutral"]["base"]["white"],
      overlay: lightColorBase["neutral"]["base"]["white"],
      sunken: lightColorBase["transparent"]["4"],
      navbar: lightColorBase["brand"]["iris"]["950"],
      topbar: lightColorBase["brand"]["iris"]["950"],
      base: lightColorBase["neutral"]["base"]["white"],
    },
  },
  text: {
    default: lightColorBase["neutral"]["granite"]["800"],
    strong: lightColorBase["neutral"]["base"]["black"],
    med: lightColorBase["neutral"]["granite"]["600"],
    weak: lightColorBase["neutral"]["granite"]["500"],
    inverse: lightColorBase["neutral"]["granite"]["25"],
    brand: {
      default: lightColorBase["brand"]["iris"]["500"],
      strong: lightColorBase["brand"]["iris"]["800"],
      weak: lightColorBase["brand"]["iris"]["400"],
      inverse: lightColorBase["brand"]["iris"]["100"],
    },
    chip: {
      negative: lightColorBase["brand"]["blush"]["600"],
      positive: lightColorBase["brand"]["meadow"]["600"],
      summary: lightColorBase["brand"]["ultramarine"]["600"],
      chapterTopic: lightColorBase["accents"]["teal"]["500"],
      question: lightColorBase["brand"]["clementine"]["600"],
      actionItem: lightColorBase["brand"]["iris"]["600"],
      feed: lightColorBase["accents"]["indigo"]["500"],
      notes: lightColorBase["accents"]["green"]["500"],
      metrics: lightColorBase["accents"]["teal"]["500"],
      participants: lightColorBase["accents"]["blue"]["500"],
      related: lightColorBase["accents"]["magenta"]["500"],
      average: lightColorBase["brand"]["clementine"]["600"],
    },
    indicator: {
      success: {
        default: lightColorBase["brand"]["meadow"]["600"],
      },
      info: {
        default: lightColorBase["brand"]["ultramarine"]["600"],
      },
      danger: {
        default: lightColorBase["brand"]["persianRed"]["600"],
      },
      warning: {
        default: lightColorBase["brand"]["clementine"]["600"],
      },
      more: {
        default: lightColorBase["neutral"]["granite"]["600"],
      },
    },
    avatar: {
      themePink: lightColorBase["accents"]["pink"]["500"],
      themeRed: lightColorBase["accents"]["red"]["500"],
      themeRedorange: lightColorBase["accents"]["redOrange"]["500"],
      themeOrange: lightColorBase["accents"]["orange"]["500"],
      themeYellow: lightColorBase["accents"]["yellow"]["500"],
      themeYellowgreen: lightColorBase["accents"]["yellowGreen"]["500"],
      themeGreen: lightColorBase["accents"]["green"]["500"],
      themeTeal: lightColorBase["accents"]["teal"]["500"],
      themeBlue: lightColorBase["accents"]["blue"]["500"],
      themeIndigo: lightColorBase["accents"]["indigo"]["500"],
      themePurple: lightColorBase["accents"]["purple"]["500"],
      themeMagenta: lightColorBase["accents"]["magenta"]["500"],
    },
    neutral: {
      default: lightColorBase["neutral"]["ghost"]["500"],
      strong: lightColorBase["neutral"]["ghost"]["700"],
      med: lightColorBase["neutral"]["ghost"]["300"],
      weak: lightColorBase["neutral"]["ghost"]["100"],
    },
  },
  icon: {
    default: lightColorBase["neutral"]["granite"]["800"],
    strong: lightColorBase["neutral"]["base"]["white"],
    med: lightColorBase["neutral"]["granite"]["600"],
    weak: lightColorBase["neutral"]["granite"]["500"],
    inverse: lightColorBase["neutral"]["granite"]["25"],
    brand: {
      default: lightColorBase["brand"]["iris"]["500"],
      strong: lightColorBase["brand"]["iris"]["800"],
      weak: lightColorBase["brand"]["iris"]["400"],
      inverse: lightColorBase["brand"]["iris"]["100"],
    },
    indicator: {
      warning: {
        default: lightColorBase["brand"]["clementine"]["600"],
      },
      danger: {
        default: lightColorBase["brand"]["persianRed"]["600"],
      },
      info: {
        default: lightColorBase["brand"]["ultramarine"]["600"],
      },
      success: {
        default: lightColorBase["brand"]["meadow"]["600"],
      },
      more: {
        default: lightColorBase["neutral"]["granite"]["50"],
      },
    },
    neutral: {
      default: lightColorBase["neutral"]["ghost"]["500"],
      strong: lightColorBase["neutral"]["ghost"]["700"],
      med: lightColorBase["neutral"]["ghost"]["300"],
      weak: lightColorBase["neutral"]["ghost"]["100"],
    },
  },
  bg: {
    highlight: {
      default: lightColorBase["neutral"]["ghost"]["100"],
      strong: lightColorBase["neutral"]["ghost"]["200"],
    },
    brand: {
      default: lightColorBase["brand"]["iris"]["500"],
      strong: lightColorBase["brand"]["iris"]["800"],
      weak: lightColorBase["brand"]["iris"]["100"],
    },
    avatar: {
      themePink: lightColorBase["accents"]["pink"]["200"],
      themeRed: lightColorBase["accents"]["red"]["200"],
      themeRedorange: lightColorBase["accents"]["redOrange"]["200"],
      themeOrange: lightColorBase["accents"]["orange"]["200"],
      themeYellow: lightColorBase["accents"]["yellow"]["200"],
      themeYellowgreen: lightColorBase["accents"]["yellowGreen"]["200"],
      themeGreen: lightColorBase["accents"]["green"]["200"],
      themeTeal: lightColorBase["accents"]["teal"]["200"],
      themeBlue: lightColorBase["accents"]["blue"]["200"],
      themeIndigo: lightColorBase["accents"]["indigo"]["200"],
      themePurple: lightColorBase["accents"]["purple"]["200"],
      themeMagenta: lightColorBase["accents"]["magenta"]["200"],
    },
    warning: {
      default: lightColorBase["brand"]["clementine"]["100"],
      hover: lightColorBase["brand"]["clementine"]["200"],
      down: lightColorBase["brand"]["clementine"]["300"],
    },
    danger: {
      default: lightColorBase["brand"]["persianRed"]["100"],
      hover: lightColorBase["brand"]["persianRed"]["200"],
      down: lightColorBase["brand"]["persianRed"]["300"],
    },
    info: {
      default: lightColorBase["brand"]["ultramarine"]["100"],
      hover: lightColorBase["brand"]["ultramarine"]["200"],
      down: lightColorBase["brand"]["ultramarine"]["300"],
    },
    success: {
      default: lightColorBase["brand"]["meadow"]["100"],
      hover: lightColorBase["brand"]["meadow"]["200"],
      down: lightColorBase["brand"]["meadow"]["300"],
    },
    chip: {
      base: lightColorBase["transparent"]["8"],
      strong: lightColorBase["transparent"]["12"],
      weak: {
        base: lightColorBase["transparent"]["4"],
        summary: lightColorBase["brand"]["ultramarine"]["50"],
        chapterTopic: lightColorBase["accents"]["teal"]["100"],
        question: lightColorBase["brand"]["clementine"]["50"],
        actionItem: lightColorBase["brand"]["iris"]["50"],
        feed: lightColorBase["accents"]["indigo"]["100"],
        notes: lightColorBase["accents"]["green"]["100"],
        metrics: lightColorBase["accents"]["teal"]["100"],
        participants: lightColorBase["accents"]["blue"]["100"],
        related: lightColorBase["accents"]["magenta"]["100"],
      },
      default: {
        summary: lightColorBase["brand"]["ultramarine"]["100"],
        question: lightColorBase["brand"]["clementine"]["100"],
        actionItem: lightColorBase["brand"]["iris"]["100"],
        chapterTopic: lightColorBase["accents"]["teal"]["200"],
        notes: lightColorBase["accents"]["green"]["200"],
        feed: lightColorBase["accents"]["indigo"]["200"],
        metrics: lightColorBase["accents"]["teal"]["200"],
        participants: lightColorBase["accents"]["blue"]["200"],
        related: lightColorBase["accents"]["magenta"]["200"],
      },
      positive: lightColorBase["brand"]["meadow"]["100"],
      negative: lightColorBase["brand"]["blush"]["100"],
      average: lightColorBase["brand"]["clementine"]["100"],
      info: lightColorBase["brand"]["ultramarine"]["200"],
    },
    neutral: {
      default: lightColorBase["neutral"]["base"]["white"],
    },
  },
  outline: {
    brand: lightColorBase["brand"]["iris"]["500"],
    default: lightColorBase["transparent"]["8"],
    strong: lightColorBase["transparent"]["12"],
  },
  tooltip: {
    bg: lightColorBase["neutral"]["granite"]["900"],
    text: lightColorBase["neutral"]["base"]["white"],
    link: lightColorBase["brand"]["ultramarine"]["400"],
  },
  dropdown: {
    primary: {
      bg: {
        default: lightColorBase["neutral"]["base"]["white"],
        disabled: lightColorBase["transparent"]["4"],
      },
      icon: {
        default: lightColorBase["neutral"]["granite"]["600"],
        disabled: lightColorBase["transparent"]["30"],
      },
      text: {
        default: lightColorBase["neutral"]["granite"]["800"],
        disabled: lightColorBase["transparent"]["30"],
      },
      outline: {
        default: lightColorBase["transparent"]["8"],
        hover: lightColorBase["transparent"]["30"],
        down: lightColorBase["brand"]["iris"]["500"],
        disabled: lightColorBase["transparent"]["8"],
      },
    },
    accent: {
      bg: {
        default: lightColorBase["brand"]["iris"]["800"],
        disabled: darkColorBase["transparent"]["8"],
        down: lightColorBase["brand"]["iris"]["500"],
        hover: lightColorBase["brand"]["iris"]["700"],
      },
      icon: {
        default: lightColorBase["neutral"]["granite"]["25"],
        disabled: darkColorBase["transparent"]["40"],
      },
      text: {
        default: lightColorBase["neutral"]["granite"]["25"],
        disabled: darkColorBase["transparent"]["50"],
      },
    },
  },
};
export const darkColorPalette = {
  button: {
    primary: {
      bg: {
        default: darkColorBase["brand"]["ultramarine"]["300"],
        hover: darkColorBase["brand"]["ultramarine"]["400"],
        down: darkColorBase["brand"]["ultramarine"]["500"],
      },
      text: darkColorBase["neutral"]["base"]["black"],
      icon: darkColorBase["neutral"]["base"]["black"],
    },
    secondary: {
      bg: {
        default: darkColorBase["transparent"]["4"],
        hover: darkColorBase["transparent"]["8"],
        down: darkColorBase["transparent"]["12"],
      },
      text: darkColorBase["neutral"]["base"]["black"],
      outline: lightColorBase["brand"]["iris"]["500"],
      icon: darkColorBase["neutral"]["base"]["black"],
    },
    disabled: {
      bg: {
        disabled: darkColorBase["transparent"]["4"],
      },
      text: darkColorBase["transparent"]["20"],
      icon: darkColorBase["transparent"]["20"],
    },
    danger: {
      bg: {
        default: darkColorBase["brand"]["persianRed"]["200"],
        hover: darkColorBase["brand"]["persianRed"]["300"],
        down: darkColorBase["brand"]["persianRed"]["400"],
      },
      text: darkColorBase["neutral"]["base"]["black"],
      icon: darkColorBase["neutral"]["base"]["black"],
    },
    dangerSecondary: {
      bg: {
        default: darkColorBase["transparent"]["4"],
        hover: darkColorBase["transparent"]["8"],
        down: darkColorBase["transparent"]["12"],
      },
      text: darkColorBase["brand"]["persianRed"]["600"],
      outline: darkColorBase["brand"]["persianRed"]["600"],
      icon: darkColorBase["brand"]["persianRed"]["600"],
    },
    strong: {
      icon: darkColorBase["neutral"]["base"]["white"],
      text: darkColorBase["neutral"]["base"]["white"],
      bg: {
        default: darkColorBase["transparent"]["90"],
        hover: darkColorBase["transparent"]["80"],
        down: darkColorBase["transparent"]["70"],
      },
    },
  },
  elevation: {
    surface: {
      default: darkColorBase["neutral"]["ghost"]["25"],
      raised: darkColorBase["neutral"]["base"]["white"],
      overlay: darkColorBase["neutral"]["granite"]["200"],
      sunken: darkColorBase["neutral"]["granite"]["25"],
      navbar: darkColorBase["brand"]["iris"]["900"],
      topbar: darkColorBase["brand"]["iris"]["950"],
      base: darkColorBase["neutral"]["base"]["white"],
    },
  },
  text: {
    default: darkColorBase["neutral"]["granite"]["800"],
    strong: darkColorBase["neutral"]["base"]["black"],
    med: darkColorBase["neutral"]["granite"]["600"],
    weak: darkColorBase["neutral"]["granite"]["500"],
    inverse: darkColorBase["neutral"]["granite"]["25"],
    brand: {
      default: darkColorBase["brand"]["ultramarine"]["500"],
      strong: darkColorBase["brand"]["ultramarine"]["800"],
      weak: darkColorBase["brand"]["ultramarine"]["400"],
      inverse: lightColorBase["brand"]["ultramarine"]["100"],
    },
    chip: {
      negative: darkColorBase["brand"]["blush"]["600"],
      positive: darkColorBase["brand"]["meadow"]["600"],
      summary: darkColorBase["brand"]["ultramarine"]["600"],
      chapterTopic: darkColorBase["accents"]["teal"]["500"],
      question: darkColorBase["brand"]["clementine"]["600"],
      actionItem: darkColorBase["brand"]["iris"]["600"],
      feed: darkColorBase["accents"]["indigo"]["500"],
      notes: darkColorBase["accents"]["green"]["500"],
      metrics: darkColorBase["accents"]["teal"]["500"],
      participants: darkColorBase["accents"]["blue"]["500"],
      related: darkColorBase["accents"]["magenta"]["500"],
      average: darkColorBase["brand"]["clementine"]["600"],
    },
    indicator: {
      success: {
        default: darkColorBase["brand"]["meadow"]["600"],
      },
      info: {
        default: darkColorBase["brand"]["ultramarine"]["600"],
      },
      danger: {
        default: darkColorBase["brand"]["persianRed"]["600"],
      },
      warning: {
        default: darkColorBase["brand"]["clementine"]["600"],
      },
      more: {
        default: lightColorBase["neutral"]["granite"]["25"],
      },
    },
    avatar: {
      themePink: darkColorBase["accents"]["pink"]["500"],
      themeRed: darkColorBase["accents"]["red"]["500"],
      themeRedorange: darkColorBase["accents"]["redOrange"]["500"],
      themeOrange: darkColorBase["accents"]["orange"]["500"],
      themeYellow: darkColorBase["accents"]["yellow"]["500"],
      themeYellowgreen: darkColorBase["accents"]["yellowGreen"]["500"],
      themeGreen: darkColorBase["accents"]["green"]["500"],
      themeTeal: darkColorBase["accents"]["teal"]["500"],
      themeBlue: darkColorBase["accents"]["blue"]["500"],
      themeIndigo: darkColorBase["accents"]["indigo"]["500"],
      themePurple: darkColorBase["accents"]["purple"]["500"],
      themeMagenta: darkColorBase["accents"]["magenta"]["500"],
    },
    neutral: {
      default: darkColorBase["neutral"]["ghost"]["500"],
      strong: darkColorBase["neutral"]["ghost"]["700"],
      med: darkColorBase["neutral"]["ghost"]["300"],
      weak: darkColorBase["neutral"]["ghost"]["100"],
    },
  },
  icon: {
    default: darkColorBase["neutral"]["granite"]["800"],
    strong: darkColorBase["neutral"]["base"]["white"],
    med: darkColorBase["neutral"]["granite"]["600"],
    weak: darkColorBase["neutral"]["granite"]["500"],
    inverse: darkColorBase["neutral"]["granite"]["25"],
    brand: {
      default: darkColorBase["brand"]["ultramarine"]["500"],
      strong: darkColorBase["brand"]["ultramarine"]["800"],
      weak: darkColorBase["brand"]["ultramarine"]["400"],
      inverse: lightColorBase["brand"]["ultramarine"]["100"],
    },
    indicator: {
      warning: {
        default: darkColorBase["brand"]["clementine"]["600"],
      },
      danger: {
        default: darkColorBase["brand"]["persianRed"]["600"],
      },
      info: {
        default: darkColorBase["brand"]["ultramarine"]["600"],
      },
      success: {
        default: darkColorBase["brand"]["meadow"]["600"],
      },
      more: {
        default: lightColorBase["neutral"]["granite"]["900"],
      },
    },
    neutral: {
      default: darkColorBase["neutral"]["ghost"]["500"],
      strong: darkColorBase["neutral"]["ghost"]["700"],
      med: darkColorBase["neutral"]["ghost"]["300"],
      weak: darkColorBase["neutral"]["ghost"]["100"],
    },
  },
  bg: {
    highlight: {
      default: darkColorBase["neutral"]["ghost"]["100"],
      strong: darkColorBase["neutral"]["ghost"]["200"],
    },
    brand: {
      default: darkColorBase["brand"]["ultramarine"]["300"],
      strong: darkColorBase["brand"]["ultramarine"]["800"],
      weak: darkColorBase["brand"]["ultramarine"]["100"],
    },
    avatar: {
      themePink: darkColorBase["accents"]["pink"]["200"],
      themeRed: darkColorBase["accents"]["red"]["200"],
      themeRedorange: darkColorBase["accents"]["redOrange"]["200"],
      themeOrange: darkColorBase["accents"]["orange"]["200"],
      themeYellow: darkColorBase["accents"]["yellow"]["200"],
      themeYellowgreen: darkColorBase["accents"]["yellowGreen"]["200"],
      themeGreen: darkColorBase["accents"]["green"]["200"],
      themeTeal: darkColorBase["accents"]["teal"]["200"],
      themeBlue: darkColorBase["accents"]["blue"]["200"],
      themeIndigo: darkColorBase["accents"]["indigo"]["200"],
      themePurple: darkColorBase["accents"]["purple"]["200"],
      themeMagenta: darkColorBase["accents"]["magenta"]["200"],
    },
    warning: {
      default: darkColorBase["brand"]["clementine"]["100"],
      hover: darkColorBase["brand"]["clementine"]["200"],
      down: darkColorBase["brand"]["clementine"]["300"],
    },
    danger: {
      default: darkColorBase["brand"]["persianRed"]["100"],
      hover: darkColorBase["brand"]["persianRed"]["200"],
      down: darkColorBase["brand"]["persianRed"]["300"],
    },
    info: {
      default: darkColorBase["brand"]["ultramarine"]["100"],
      hover: darkColorBase["brand"]["ultramarine"]["200"],
      down: darkColorBase["brand"]["ultramarine"]["300"],
    },
    success: {
      default: darkColorBase["brand"]["meadow"]["100"],
      hover: darkColorBase["brand"]["meadow"]["200"],
      down: darkColorBase["brand"]["meadow"]["300"],
    },
    chip: {
      base: darkColorBase["transparent"]["8"],
      strong: darkColorBase["transparent"]["12"],
      weak: {
        base: darkColorBase["transparent"]["4"],
        summary: darkColorBase["brand"]["ultramarine"]["50"],
        chapterTopic: darkColorBase["accents"]["teal"]["100"],
        question: darkColorBase["brand"]["clementine"]["50"],
        actionItem: darkColorBase["brand"]["iris"]["50"],
        feed: darkColorBase["accents"]["indigo"]["100"],
        notes: darkColorBase["accents"]["green"]["100"],
        metrics: darkColorBase["accents"]["teal"]["100"],
        participants: darkColorBase["accents"]["blue"]["100"],
        related: darkColorBase["accents"]["magenta"]["100"],
      },
      default: {
        summary: darkColorBase["brand"]["ultramarine"]["100"],
        question: darkColorBase["brand"]["clementine"]["100"],
        actionItem: darkColorBase["brand"]["iris"]["100"],
        chapterTopic: darkColorBase["accents"]["teal"]["200"],
        notes: darkColorBase["accents"]["green"]["200"],
        feed: darkColorBase["accents"]["indigo"]["200"],
        metrics: darkColorBase["accents"]["teal"]["200"],
        participants: darkColorBase["accents"]["blue"]["200"],
        related: darkColorBase["accents"]["magenta"]["200"],
      },
      positive: darkColorBase["brand"]["meadow"]["100"],
      negative: darkColorBase["brand"]["blush"]["100"],
      average: darkColorBase["brand"]["clementine"]["100"],
      info: darkColorBase["brand"]["ultramarine"]["200"],
    },
    neutral: {
      default: lightColorBase["neutral"]["base"]["black"],
    },
  },
  outline: {
    brand: darkColorBase["brand"]["ultramarine"]["500"],
    default: darkColorBase["transparent"]["8"],
    strong: darkColorBase["transparent"]["12"],
  },
  tooltip: {
    bg: darkColorBase["neutral"]["granite"]["900"],
    text: lightColorBase["neutral"]["granite"]["800"],
    link: lightColorBase["brand"]["ultramarine"]["500"],
  },
  dropdown: {
    primary: {
      bg: {
        default: darkColorBase["neutral"]["base"]["white"],
        disabled: darkColorBase["transparent"]["4"],
      },
      icon: {
        default: darkColorBase["neutral"]["granite"]["600"],
        disabled: darkColorBase["transparent"]["30"],
      },
      text: {
        default: darkColorBase["neutral"]["granite"]["800"],
        disabled: darkColorBase["transparent"]["30"],
      },
      outline: {
        default: darkColorBase["transparent"]["8"],
        hover: darkColorBase["transparent"]["30"],
        down: darkColorBase["brand"]["iris"]["500"],
        disabled: darkColorBase["transparent"]["8"],
      },
    },
    accent: {
      bg: {
        default: darkColorBase["brand"]["iris"]["800"],
        disabled: lightColorBase["transparent"]["8"],
        down: darkColorBase["brand"]["iris"]["600"],
        hover: darkColorBase["brand"]["iris"]["700"],
      },
      icon: {
        default: darkColorBase["neutral"]["granite"]["25"],
        disabled: lightColorBase["transparent"]["30"],
      },
      text: {
        default: darkColorBase["neutral"]["granite"]["25"],
        disabled: lightColorBase["transparent"]["40"],
      },
    },
  },
};

export type ColorPalette = typeof lightColorPalette;

export type PulseTextColor = ColorPalette["text"];
